export const BeslagType = {
    TRADITIONEEL: "traditioneel",
    OUDHOLLANDS: "Oudhollands",
}

export const MontageType = {
    MUUR: "muur",
    KOZIJN: "kozijn",
}

export const DraaiType = {
    AL: "AL",
    AR: "AR",
    B: "B",
}

export const HengType = {
    T2: "T2",
    L2: "L2",
    H2: "H2",
    T3: "T3",
    L3: "L3",
    HT3: "HT3",
    LT3: "LT3",
}

export const Luiksluiting = {
    NO_CLOSING: "geen luiksluiting",
    TYPE_A: "type A",
    TYPE_D: "type D",
    MACO: "Maco",
    TRADITIONEEL: "traditioneel",
    OUDHOLLANDS: "Oudhollands",
}

export const Luikvastzetter = {
    NO_FASTENER: "geen luikvastzetter",
    HERDERINNEKOPJE_TYPE_B_16_30: "herderinnekopje type b 16-30",
    HERDERINNEKOPJE_TYPE_B_30_55: "herderinnekopje type b 30-55",
    HOLLANDSE_LUIKWERVEL: "Hollandse luikwervel",
    LUIKWERVEL_MARSEILLE: "luikwervel Marseille",
    VERBORGEN_LUIKVASTZETTER_MACO: "verborgen luikvastzetter Maco",
    AUTOMATISCHE_LUIKVASTZETTER_ZWART: "automatische luikvastzetter zwart",
    COMFORT_SLUITING: "comfort sluiting",
}
